var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('all-notifications'),_c('div',{staticClass:"dashboard-wrapper"},[_c('vertical-nav-menu'),_c('div',{staticClass:"dashboard-container"},[_c('router-view'),_c('mobile-open-sidebar')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }